/* unplugin-vue-components disabled */import { render } from "./ExamBox.vue?vue&type=template&id=61f4db28&scoped=true"
import script from "./ExamBox.vue?vue&type=script&lang=js"
export * from "./ExamBox.vue?vue&type=script&lang=js"

import "./ExamBox.vue?vue&type=style&index=0&id=61f4db28&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f4db28"]])

export default __exports__